import { render, staticRenderFns } from "./load-spinner.vue?vue&type=template&id=4cf1cc5b&"
import script from "./load-spinner.vue?vue&type=script&lang=ts&"
export * from "./load-spinner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports